import { compose, withHandlers, lifecycle, withState } from 'recompose';
import moment from 'moment';
import { get, find } from 'lodash';
import { loadPrices } from '../prices/_api';
import { formulaForPrice } from '../../utils/config';

const enhance = compose(
  withState('priceConfig', 'setPriceConfig', null),
  lifecycle({
    async componentDidMount() {
      const { setPriceConfig } = this.props;
      const resp = await loadPrices();
      setPriceConfig(resp);
    }
  }),
  withHandlers({
    countPrice: ({ from, priceConfig }) => (
      daysCount,
      category,
      type,
      params = {},
      from1 = null
    ) => {
      from = from1 ? from1 : from;
      if (category === 'LYZAKY') {
        const length = get(params, 'size', 240);
        if (parseFloat(length) > 235) {
          const priceSettings = get(priceConfig, `${category}`);
          return formulaForPrice(priceSettings, daysCount);
        } else {
          const priceSettings = get(priceConfig, `${category}<235`);
          return formulaForPrice(priceSettings, daysCount);
        }
      }
      if (category === 'LYZE') {
        const typeSki = get(params, 'skiType', 'Standard');

        if (typeSki === 'Standard') {
          const priceSettings = get(priceConfig, `${category}`);
          return formulaForPrice(priceSettings, daysCount);
        }
        if (typeSki === 'TOP') {
          const priceSettings = get(priceConfig, `${category}_TOP`);
          return formulaForPrice(priceSettings, daysCount);
        }
        if (typeSki === 'Dětské do 130cm') {
          const priceSettings = get(priceConfig, `${category}<130`);
          return formulaForPrice(priceSettings, daysCount);
        }
      }
      if (category === 'VAK' && type === 'snowboard') {
        return 0;
      }
      const priceSettings = get(priceConfig, `${category}`);
      return formulaForPrice(priceSettings, daysCount);
    }
  }),
  withHandlers({
    serveItems: ({ countPrice }) => (items, type = 'downhill', daysCount) => {
      const category = get(items, 'categoryId');
      let itemsToShow = [];
      get(items, 'productsWithItems', []).map(item => {
        let labelProduct = [];
        let price = 0;
        let sorting;
        if (['LYZAKY', 'BOTY_SNB', 'BOTY_BEH'].includes(category)) {
          labelProduct.push(
            get(
              find(get(item, 'attributes', []), { attributeId: 15 /*'Velikost boty'*/ }),
              'value',
              'neuvedeno'
            ).replace(/\s/g, '')
          );
          const size1 = parseFloat(labelProduct[0].split('/')[0].replace(',', '.'));
          price = countPrice(daysCount, category, type, { size: size1 * 10 });
          sorting = size1;
        }
        if (['LYZE', 'BEZKY'].includes(category)) {
          const size = get(
            find(get(item, 'attributes', []), { attributeId: 13 /*'Délka lyží'*/ }),
            'value',
            'neuvedeno'
          ).replace(/\s/g, '');
          labelProduct.push(size);
          sorting = parseInt(size, 10);
          if (category === 'BEZKY') {
            price = countPrice(daysCount, category);
          }
        }
        if (category === 'SNB') {
          const size = get(
            find(get(item, 'attributes', []), { attributeId: 16 /*'Délka SNB'*/ }),
            'value',
            'neuvedeno'
          ).replace(/\s/g, '');
          labelProduct.push(size);
          sorting = parseInt(size, 10);
          price = countPrice(daysCount, category);
        }
        if (['HOLE_SJEZD', 'HOLE_BEH'].includes(category)) {
          const size = get(
            find(get(item, 'attributes', []), {
              attributeId: category === 'HOLE_SJEZD' ? 24 : 25 /*'Sjezdové hole' : 'Hole běžecké'*/
            }),
            'value',
            'neuvedeno'
          ).replace(/\s/g, '');
          labelProduct.push(`${size} cm`);
          sorting = parseInt(size, 10);
          price = countPrice(daysCount, category);
        }
        if (category === 'PRILBY') {
          const size = get(
            find(get(item, 'attributes', []), { attributeId: 14 /*'Velikost přilby'*/ }),
            'value',
            'neuvedeno'
          ).replace(/\s/g, '');
          labelProduct.push(`${size} cm`);
          sorting = parseInt(size, 10);
          price = countPrice(daysCount, category);
        }
        if (['VAK', 'TASKA'].includes(category)) {
          price = countPrice(daysCount, category, type);
        }
        if (category === 'BRYLE') {
          const size = get(
            find(get(item, 'attributes', []), { attributeId: 26 /*'Brýle lyžařské'*/ }),
            'value',
            'neuvedeno'
          ).replace(/\s/g, '');
          labelProduct.push(size);
          price = countPrice(daysCount, category);
        }

        if (category === 'PATERAK') {
          const size = get(
            find(get(item, 'attributes', []), { attributeId: 33 /*'Brýle lyžařské'*/ }),
            'value',
            'neuvedeno'
          ).replace(/\s/g, '');
          labelProduct.push(`${size} cm`);
          price = countPrice(daysCount, category);
        }

        get(item, 'items', []).map(item2 => {
          const label = [...labelProduct];
          if (!['HOLE_SJEZD', 'HOLE_BEH', 'BRYLE', 'PATERAK'].includes(category)) {
            label.push(item2.serialNumber);
          }
          if (category === 'LYZE') {
            const skiType = get(
              find(get(item2, 'attributes', []), { attributeId: 18 /*'Kategorie lyží'*/ }),
              'value',
              'neuvedeno'
            );
            price = countPrice(daysCount, category, type, { skiType });
            label.push(skiType);
          }
          itemsToShow.push({
            id: item2.id,
            price,
            sorting,
            serial: parseInt(get(item2, 'serialNumber'), 10),
            label: label.join('-'),
            requestId: get(items, 'requestServerUid', null)
          });
          return {};
        });
        return {};
      });
      return itemsToShow.sort((a, b) => {
        if (a.sorting === b.sorting) {
          return a.serial - b.serial;
        } else {
          return a.sorting - b.sorting;
        }
      });
    },
    countDays: () => (from, to) => {
      if (!from || !to) {
        return null;
      }

      const from1 = moment(from).format('YYYY-MM-DD 00:00:00');
      const to1 = moment(to).format('YYYY-MM-DD 23:59:59');
      if (moment(from1) > moment(to1)) {
        return null;
      }

      const count = moment(to1).diff(moment(from1), 'days');
      return count <= 0 ? 1 : count;
    }
  })
);

export default enhance;



// WEBPACK FOOTER //
// ./src/modules/reservations/withCountPriceServeItem.js